import { useLocalSearchParams, useRouter } from 'expo-router';
import { INCENTIVE_PARAM } from 'features/rewards/constants/constants';
import React from 'react';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';

import MultiStepIncentiveScreen from './MultiStepIncentiveScreen/MultiStepIncentiveScreen';
import PartnerOfferDetailsV2 from './PartnerOfferDetailsV2/PartnerOfferDetailsV2';

const RewardDetailsScreen = () => {
  const router = useRouter();
  const { id, style, sectionName } = useLocalSearchParams<{
    id: string;
    style: string;
    sectionName: string;
  }>();

  const { defaultTitle, defaultMessage, cancelButtonTitle } =
    useDefaultErrorStrings();

  const ErrorScreenComponent = (
    <ErrorScreen
      screenType={ErrorScreenType.Error}
      messageHeadline={defaultTitle}
      messageBody={defaultMessage}
      primaryButton={{
        title: cancelButtonTitle as string,
        onPress: () => router.back(),
      }}
    />
  );

  const props = {
    id: id,
    sectionName: sectionName,
    ErrorComponent: ErrorScreenComponent,
  };

  if (style === INCENTIVE_PARAM) {
    return <MultiStepIncentiveScreen {...props} />;
  }

  return <PartnerOfferDetailsV2 {...props} />;
};

export default RewardDetailsScreen;
